import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { formatRequestNumber as formatTransactionNumber } from "fe-shared-requests/src/helpers/format";

import styles from "./PickupRequestTransactionLink.module.scss";

interface Props {
  transactionNumber?: string | null;
  canOpenTransaction: boolean;
  kind: "shipment" | "pickup";
}

const PickupRequestTransactionLink = ({
  transactionNumber,
  canOpenTransaction,
  kind,
}: Props) => {
  const { t } = useTranslation();

  if (!transactionNumber) {
    return null;
  }

  const label = t(
    kind === "shipment"
      ? "pickupRequests.details.linkedShipmentTransaction"
      : "pickupRequests.details.linkedPickupTransaction"
  );
  const number = formatTransactionNumber(transactionNumber);

  const text = `${label} ${number}`;

  return (
    <div className={styles.row}>
      {canOpenTransaction ? (
        <Link
          className={`${styles.text} ${styles.link}`}
          to={`/transactions/${transactionNumber}`}
        >
          {text}
        </Link>
      ) : (
        <span className={styles.text}>{text}</span>
      )}
    </div>
  );
};

export default PickupRequestTransactionLink;
